import React, { useEffect, useState } from "react";
import StablePrime from "../../components/Tables/StablePrime";
import UploadEtBomFile from "../../components/Upload/UploadEtBomFile";

 const UploadPlanFile4 = ({ setPageHeader }) =>  {
  const [fileResponse, setFileResponse] = useState();
  
  if(setPageHeader){
    setPageHeader("Upload BOM");
  }

  return (
    <div>
      <UploadEtBomFile setFileResponse={setFileResponse} />
      {
        fileResponse && (
          <StablePrime zenTable={true} tableData={fileResponse} />
        )
      }
    </div>
  );
}

export default UploadPlanFile4;
